










import { Component, Prop, Vue } from 'vue-property-decorator'
import { MedicalBusiness } from '@/interface/api'

@Component({})
export default class Header extends Vue {
  @Prop({ default: () => '' }) private medicalbusinessId!: string
  @Prop({ default: () => null }) private medicalbusiness!: MedicalBusiness
}
